var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMyr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4785 12.2689H24.0002C24.0002 11.1857 23.8559 10.1366 23.5869 9.13843H11.4785V12.2689Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4785 6.00716H22.239C21.5044 4.80847 20.5652 3.74896 19.4701 2.87671H11.4785V6.00716Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 24.2666C14.8253 24.2666 17.4211 23.2905 19.471 21.658H4.53125C6.58114 23.2905 9.17694 24.2666 12.0011 24.2666Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76195 18.5267H22.2394C22.8291 17.5644 23.2864 16.5125 23.5873 15.3962H0.414062C0.714859 16.5125 1.17222 17.5644 1.76195 18.5267Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.2673C12 5.63996 12 4.85865 12 0.267334C5.37262 0.267334 0 5.63996 0 12.2673H12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98099 10.5392C6.34214 10.5392 5.01361 9.2106 5.01361 7.5718C5.01361 5.93301 6.34219 4.60443 7.98099 4.60443C8.49197 4.60443 8.97277 4.73366 9.39254 4.9611C8.73404 4.31718 7.83347 3.91968 6.83967 3.91968C4.82269 3.91968 3.1875 5.55482 3.1875 7.57185C3.1875 9.58888 4.82269 11.224 6.83967 11.224C7.83347 11.224 8.73404 10.8265 9.39254 10.1826C8.97277 10.4099 8.49202 10.5392 7.98099 10.5392Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81842 5.48608L9.34525 6.58774L10.535 6.31287L10.0022 7.41157L10.959 8.17033L9.76773 8.43888L9.77106 9.66002L8.81842 8.89605L7.86573 9.66002L7.86902 8.43888L6.67773 8.17033L7.63455 7.41157L7.10172 6.31287L8.29155 6.58774L8.81842 5.48608Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMyr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MYR.cd94b80feb897d38e20028970cd01cc8.svg";